import React from "react";

import { VStack } from "@whoosh/design-system/src/components/primitive";

import { RestrictionFeature } from "../../types";
import { RestrictionInfoBar } from "../RestrictionInfoBar/RestrictionInfoBar";
import { shouldShowBar } from "../RestrictionInfoBar/utils/shouldShowBar/shouldShowBar";

type RestrictionInfoBarStackProps = {
  restrictions: RestrictionFeature.RestrictionBarData[];
  restrictionContext: "Staff" | "Patron";
};

export const RestrictionInfoBarStack = ({
  restrictions,
  restrictionContext,
}: RestrictionInfoBarStackProps) => {
  const hasAtLeastOneRestrictionToDisplay = restrictions.some((restriction) =>
    shouldShowBar(restriction, restrictionContext)
  );

  return hasAtLeastOneRestrictionToDisplay ? (
    <VStack gap={1} paddingBottom={2} testID="restriction-info-bar-stack">
      {restrictions.map((restriction) => (
        <RestrictionInfoBar
          key={restriction.rule.name}
          restriction={restriction}
          restrictionContext={restrictionContext}
        />
      ))}
    </VStack>
  ) : null;
};
